export const TOKEN_KEY = {
  TOKEN_TYPE: 'tokenType',
  ACCESS_TOKEN: 'accessToken',
  REFRESH_TOKEN: 'refreshToken',
  ACCEPT_CARD_PAYMENTS: 'acceptCardPayments',
  STRIPE_ONBOARD_STATUS: 'onboardStatus'
};
